/**
 * app-status-request.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class AppStatusRequest extends ReplyVerifyingMessage
{
    public tag : MessageTag = MessageTag.REQ_STATUS_APP;
	public static tag : MessageTag = MessageTag.REQ_STATUS_APP;

    public verifyReply (reply : Message) : boolean
    {
        return Message.isA(reply, MessageTag.RSP_STATUS_APP);
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/admin/app-status-request.ts